import coreAPIInstance from "./coreApiInstance";

export const filmstripAPIs = {
  getOrCreateFilmstrip: ({ payload }) => coreAPIInstance.post("/api/v1/filmstrip.getOrCreate", payload),
};
